import {
  type RepoIssuesDashboardDeferredResult,
  RepoIssuePullRequestReviewDecision,
  RepoIssuePullRequestState,
  RepoIssuePullRequestStatusCheckState,
} from '@github-ui/dotcom-schema/types/issues/v1/repo_issues_dashboard'

import type {IssuesListSecondaryResult} from '../components/IssuesListSurface'

function pullRequestState(state: RepoIssuePullRequestState): string | null {
  switch (state) {
    case RepoIssuePullRequestState.OPEN:
      return 'OPEN'
    case RepoIssuePullRequestState.CLOSED:
      return 'CLOSED'
    case RepoIssuePullRequestState.MERGED:
      return 'MERGED'
    case RepoIssuePullRequestState.UNSPECIFIED:
      return null
  }
}

function reviewDecision(state: RepoIssuePullRequestReviewDecision) {
  switch (state) {
    case RepoIssuePullRequestReviewDecision.APPROVED:
      return 'APPROVED' as const
    case RepoIssuePullRequestReviewDecision.CHANGES_REQUESTED:
      return 'CHANGES_REQUESTED' as const
    case RepoIssuePullRequestReviewDecision.REQUIRED:
      return 'REVIEW_REQUIRED' as const
    case RepoIssuePullRequestReviewDecision.UNSPECIFIED:
      return undefined
  }
}

function statusCheckState(state: RepoIssuePullRequestStatusCheckState) {
  switch (state) {
    case RepoIssuePullRequestStatusCheckState.SUCCESS:
      return 'SUCCESS' as const
    case RepoIssuePullRequestStatusCheckState.FAILURE:
      return 'FAILURE' as const
    case RepoIssuePullRequestStatusCheckState.PENDING:
      return 'PENDING' as const
    case RepoIssuePullRequestStatusCheckState.UNSPECIFIED:
      return undefined
  }
}

export function repoDeferredToListItem(
  result: RepoIssuesDashboardDeferredResult,
): IssuesListSecondaryResult | undefined {
  if (result.item.case === 'issue') {
    const issue = result.item.value
    return {
      itemType: 'issue',
      id: result.id,
      isReadByCurrentUser: issue.isReadByCurrentUser,
      linkedPullRequestCount: issue.linkedPullRequestCount,
      linkedPullRequests: issue.linkedPullRequests.map(pullRequest => ({
        title: pullRequest.title,
        number: pullRequest.number,
        permalink: pullRequest.permalink ?? null,
        repoNameWithOwner: pullRequest.repoNameWithOwner ?? null,
        state: pullRequestState(pullRequest.state),
        isDraft: pullRequest.isDraft,
      })),
      subIssuesSummary: issue.subIssuesSummary ?? {total: 0, completed: 0, percentCompleted: 0},
      blockedByCount: issue.blockedByCount,
      reactionGroups: issue.reactionGroups?.groups ?? null,
    }
  }

  if (result.item.case === 'pullRequest') {
    const pullRequest = result.item.value
    const state = pullRequest.statusCheckRollup && statusCheckState(pullRequest.statusCheckRollup.state)
    return {
      itemType: 'pull_request',
      id: result.id,
      reviewDecisionState: reviewDecision(pullRequest.reviewDecisionState),
      statusCheckRollup:
        pullRequest.statusCheckRollup && state
          ? {
              state,
              totalCount: pullRequest.statusCheckRollup.totalCount,
              successCount: pullRequest.statusCheckRollup.successCount,
            }
          : undefined,
      approvedReviewsCount: pullRequest.approvedReviewsCount,
      changesRequestedReviewsCount: pullRequest.changesRequestedReviewsCount,
      reactionGroups: pullRequest.reactionGroups?.groups,
    }
  }
}
